import { Activity, FolderOpen } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export interface CasesStatChipsViewProps {
  total: number
  activeCount: number
}

/** Pure stat chips for the cases dashboard header (total + active counts). */
export function CasesStatChipsView({ total, activeCount }: CasesStatChipsViewProps) {
  const { t } = useTranslation()
  if (total === 0) return null
  return (
    <div className="flex items-center gap-2 flex-wrap">
      <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-muted/60 text-xs text-muted-foreground">
        <FolderOpen className="h-3.5 w-3.5" />
        <span className="font-medium text-foreground">{total}</span>
        {'  '}
        {t('cases.dashboard.case', { count: total })}
      </div>
      <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-primary/10 text-xs text-primary">
        <Activity className="h-3.5 w-3.5" />
        <span className="font-medium">{activeCount}</span>
        {'  '}
        {t('cases.dashboard.active')}
      </div>
    </div>
  )
}
